import React from 'react';

import { MethodTester } from '@features/method-tester';

import { Footer } from '@/components/Footer';
import { Header } from '@/components/Header';
import MobileCloseHeader from '@/features/method-tester/components/MobileCloseHeader';

const HomePage: React.FC = () => {
  return (
    <>
      <MobileCloseHeader />
      <Header />
      <MethodTester />
      <Footer />
    </>
  );
};

export default HomePage;
